import { List, Record } from "immutable";

import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";

const defaults = {
  displayName: "",
  email: "",
  id: "",
  integrationId: "",
  integrationResourceRoles: null as List<IntegrationResourceRoleModel> | null,
  isDeleted: false,
  isUsed: false,
  lastUsed: null as Date | null,
  userIds: null as List<string> | null,
};

export class IntegrationActorModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): IntegrationActorModel {
    const {
      displayName,
      email,
      id,
      integrationId,
      integrationResourceRoles,
      isDeleted = false,
      lastUsed,
      userIds,
    } = data as typeof defaults;

    return new IntegrationActorModel({
      displayName,
      email,
      id,
      integrationId,
      integrationResourceRoles: integrationResourceRoles
        ? List(integrationResourceRoles.map(IntegrationResourceRoleModel.fromServerData))
        : null,
      isDeleted,
      isUsed: false, // client-side should define this when needed
      lastUsed: lastUsed ? new Date(lastUsed) : null,
      userIds: userIds ? List(userIds) : null,
    });
  }
}
